const preparationTimeAction = (data) => ({
    type: "PREPARATION_TIME",
    payload: data, 
  });
  
  export { preparationTimeAction };
  